
import { CallbacksManager } from "../../utils/CallbacksManager";
import { Api, ConnectionResponse } from "./Api";
import { Sockets } from "./Sockets";



export type MessageRecord = {
    text: string,
    timestamp: number,
    source?: string,
    durationMs?: number,
    closable: boolean,
    classes?: string[],
    timeoutId?: ReturnType<typeof setTimeout>,
    service: BackendService
};

export class BackendService {

    private readonly _api: Api;
    private readonly _sockets: Sockets;

    public get api() { return this._api; }
    public get sockets() { return this._sockets; }

    private messages: MessageRecord[] = [];
    public onMessageAdded: CallbacksManager<(message: MessageRecord, allMessages: MessageRecord[]) => void> = new CallbacksManager();
    public onMessageRemoved: CallbacksManager<(message: MessageRecord, allMessages: MessageRecord[]) => void> = new CallbacksManager();

    public onShouldReset: CallbacksManager<(withError: boolean) => void> = new CallbacksManager();
    public onValidationSuccess: CallbacksManager<() => void> = new CallbacksManager();

    public onValidationFailure: CallbacksManager<() => void> = new CallbacksManager();

    public readonly onStartedPlaying: CallbacksManager<() => void> = new CallbacksManager();
    public readonly onStoppedPlaying: CallbacksManager<() => void> = new CallbacksManager();

    constructor(
        private readonly apiUrl: string,
        private readonly apiSlug: string,
        private readonly clientSlug: string
    ) {

        this._api = new Api(
            this,
            this.apiUrl,
            this.apiSlug,
            this.clientSlug
        );

        this._sockets = new Sockets(
            this,
            this.apiUrl
        );

    }


    public async connect(): Promise<ConnectionResponse | undefined> {

        try {

            const connectionResponse = await this.api.connect();

            if (connectionResponse) {
                // Připojeno
                this.sockets.initSocket(connectionResponse!.existingSession!.sessionid);
            } else {
                throw new Error("Nepodařilo se navázat spojení s API.");
            }

            return connectionResponse;

        } catch (error) {

            const er = error as any as Error;
            this.recieveMessage(
                this.messageFactory(
                    er.message,
                    "BackendService.connect",
                    10000,
                    true,
                    ["error"]
                )
            )
        }

    }

    public async submit(
        line: string,
        imageData: string,
        colorA: string,
        colorB: string,
        comment: string
    ): Promise<boolean> {

        try {

            const result = await this.api.submit(
                line,
                colorA,
                colorB,
                imageData,
                comment
            );

            console.log("Submit result:", result);

            return result;

        } catch (error) {
            console.error("BackendService.submit error:", error);
            return false;
        }

    }

    public messageFactory(
        text: string,
        source?: string,
        durationMs?: number,
        closable: boolean = false,
        classes: string[] = []
    ): MessageRecord {

        return {
            text,
            timestamp: Date.now(),
            source,
            durationMs,
            closable,
            classes,
            service: this
        }

    }

    public recieveMessage(
        message: MessageRecord
    ) {
        this.messages.push(message);
        this.onMessageAdded.call(message, this.messages);
        if (message.durationMs !== undefined) {
            message.timeoutId = setTimeout(() => {

                this.removeMessage(message);

            }, message.durationMs);
        }

    }

    public removeMessage(
        message: MessageRecord
    ) {
        if (message.timeoutId !== undefined) {
            clearTimeout(message.timeoutId);
            message.timeoutId = undefined;
        }
        this.messages = this.messages.filter(m => m !== message);
        this.onMessageRemoved.call(message, this.messages);
    }

    public forEveryMessage(
        callback: (message: MessageRecord) => void
    ): void {
        this.messages.forEach(m => callback(m));
    }



}